import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, withLatestFrom, map } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { NoOp } from '../../ui/action-creators';
import { setLastLocation } from '../../../utils/release/last-location';
import { LocationChangeAction, LOCATION_CHANGE } from 'connected-react-router';


export const updateLastLocationEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, LocationChangeAction<any>>(LOCATION_CHANGE),
    withLatestFrom(state$),
    filter(([_, state]) => !!(
      state.release.release?.status === 'draft' &&
      state.release.release?.id &&
      state.router.location.pathname.startsWith('/release')
    )),
    map(([_, state]) => {
      const currentPath = state.router.location.pathname;
      const currentReleaseId = state.release.release?.id || '';
      const currentArtistId = state.artist.active?.id || '';

      setLastLocation(currentArtistId, currentReleaseId, currentPath);

      return new NoOp();
    })
  );